import { GetServerSidePropsContext } from 'next/types';
import { getPage } from 'evcharging/services/cmsClient';
import { getDictionary } from 'evcharging/i18n';
import { PageInterface } from 'evcharging/services/types';

export interface ENVIRONMENT {
  IS_PRODUCTION: boolean;
  // E5
  ENVIRONMENT: string;
  SITE_URL: string;
  API_BASE_URL: string;
  ASSET_URL: string;
  CONTACT_EMAIL_TO: string;
  SCHEDULE_EMAIL_TO: string;
  BLOG_EMAIL_TO: string;
  PRICING_EMAIL_TO: string;
  GOOGLE_MAP_KEY: string;
  CMS_API_BASE_URL: string;
  SCANNING_EMAIL_TO: string;
  GTM_CONTAINER_ID: string;
  GTM_AUTH: string;
  GTM_PREVIEW: string;
  GTM_COOKIES_WIN: string;
  // EVC
  HOST_URL: string;
  POST_COMMENTER_STATIC_TOKEN: string;
  RECAPTCHA_SITE_KEY: string;
  RECAPTCHA_SECRET_KEY: string;
}

export let ENV: ENVIRONMENT = {
  IS_PRODUCTION: !(process.env.HOST_URL ?? '').includes('dev.'),
  // E5
  ENVIRONMENT: process.env.ENVIRONMENT,
  SITE_URL: process.env.HOST_URL ?? '',
  API_BASE_URL: process.env.API_BASE_URL,
  ASSET_URL: process.env.ASSET_URL,
  CONTACT_EMAIL_TO: process.env.CONTACT_EMAIL_TO,
  SCHEDULE_EMAIL_TO: process.env.SCHEDULE_EMAIL_TO,
  BLOG_EMAIL_TO: process.env.BLOG_EMAIL_TO,
  PRICING_EMAIL_TO: process.env.PRICING_EMAIL_TO,
  SCANNING_EMAIL_TO: process.env.SCANNING_EMAIL_TO,
  CMS_API_BASE_URL: process.env.CMS_API_BASE_URL,
  GOOGLE_MAP_KEY: process.env.NEXT_PUBLIC_GOOGLE_MAP_KEY,
  GTM_CONTAINER_ID: process.env.GTM_CONTAINER_ID,
  GTM_AUTH: process.env.GTM_AUTH ?? '',
  GTM_PREVIEW: process.env.GTM_PREVIEW ?? '',
  GTM_COOKIES_WIN: process.env.GTM_COOKIES_WIN ?? '',
  // EVC
  HOST_URL: process.env.HOST_URL ?? '',
  POST_COMMENTER_STATIC_TOKEN: process.env.POST_COMMENTER_STATIC_TOKEN ?? '',
  RECAPTCHA_SITE_KEY: process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY ?? '',
  RECAPTCHA_SECRET_KEY: process.env.RECAPTCHA_SECRET_KEY ?? '',
};

export const setENV = (env: ENVIRONMENT) => {
  ENV = { ...env };
};

export const withENV = (pageProps = {}) => ({ ...pageProps, ENV });

export interface StaticPageProps {
  jsonLd?: string;
  page: PageInterface;
}

export const createGetServerSideProps =
  (
    link?: string,
    callback?: (context: GetServerSidePropsContext, locale: string) => Promise<any>
  ) =>
  async (context: GetServerSidePropsContext): Promise<unknown> => {
    const locale = String(context.locale);
    const page = link ? await getPage(link, locale) : {};
    const i18n = await getDictionary(locale);
    const more = callback ? await callback(context, locale) : {};

    if (more.redirect) {
      return more;
    }

    return {
      props: withENV({ page, i18n, ...more }),
    };
  };

export const GOOGLE_PLAY_LINK = 'https://play.google.com/store/apps/details?id=com.energy5.cp.app';
export const APP_STORE_LINK =
  'https://apps.apple.com/us/app/energy5-ev-charging-network/id1609966908';
export const PHONE_NUMBER = '(856) 412-4645';
export const DESKTOP_VIDEO = 'https://static.energy5.com/video/wide_desktop_compressed.mp4';
export const MOBILE_VIDEO = 'https://static.energy5.com/video/mobile_compressed.mp4';
export const YOUTUBE_VIDEO = 'https://www.youtube.com/embed/-SIk6zak9lE?autoplay=1&amp;rel=0&amp';

export const I18N_DEFAULT_LOCALE = 'en';

export const SITEMAP_PAGE_SIZE = 1000;

export const HOST_URL = 'https://energy5.com';
